import React, {PropTypes} from 'react';
import {
  DatePicker,
  FlatButton,
  MenuItem,
  RaisedButton,
  SelectField,
  Slider,
  Step,
  Stepper,
  StepLabel,
  StepContent,
  TextField
} from 'material-ui';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as projectActions from '../actions/project';
import * as taskActions from '../actions/task';

const initialState = () => {
  return {
    stepIndex: 0,
    taskName: '',
    project: null,
    hoursADay: 1,
    startAt: null,
    endAt: null,
    taskNameHasError: false,
    projectHasError: false,
    hoursADayHasError: false,
    startAtHasError: false,
    endAtHasError: false
  };
};

class NewTaskPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState();
    this.handleNext = this.handleNext.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
    this.handleSelectFieldChange = this.handleSelectFieldChange.bind(this);
    this.handleTaskChange = this.handleTaskChange.bind(this);
    this.handleHoursChange = this.handleHoursChange.bind(this);
    this.handleStartAtChange = this.handleStartAtChange.bind(this);
    this.handleEndAtChange = this.handleEndAtChange.bind(this);
  }

  componentDidMount() {
    this.props.projectActions.fetchProjects();
  }

  handleNext() {
    const {
      stepIndex,
      project,
      taskName,
      hoursADay,
      startAt,
      endAt
    } = this.state;
    let errors = false;
    //プロジェクトの選択
    if (stepIndex === 0) {
      if (project === null) {
        this.setState({projectHasError: true});
        errors = true;
      } else {
        this.setState({projectHasError: false});
      }
    }

    //タスク名と稼働時間
    if (stepIndex === 1) {
      if (taskName === '') {
        this.setState({taskNameHasError: true});
        errors = true;
      } else {
        this.setState({taskNameHasError: false});
      }
      if (hoursADay === '') {
        this.setState({hoursADayHasError: true});
        errors = true;
      } else {
        this.setState({hoursADayHasError: false});
      }
    }

    //タスク開始日/終了日
    if (stepIndex === 2) {
      if (startAt === '') {
        this.setState({startAtHasError: true});
        errors = true;
      } else {
        this.setState({startAtHasError: false});
      }
      if (endAt === '') {
        this.setState({endAtHasError: true});
        errors = true;
      } else {
        this.setState({endAtHasError: false});
      }
    }

    if (errors === false) {
      if (stepIndex === 2) {
        this.setState({
          stepIndex: stepIndex + 1
        });
        this.props.taskActions.createTask({
          name: taskName,
          hours: hoursADay,
          project: project.key,
          projectLabel: `${project.code}-${project.name}`,
          projectColor: project.color,
          startAt: startAt,
          endAt: endAt
        });
        this.setState(initialState());
      } else {
        this.setState({
          stepIndex: stepIndex + 1
        });
      }
    }
  }

  handlePrev() {
    const {stepIndex} = this.state;
    if (stepIndex > 0) {
      this.setState({stepIndex: stepIndex - 1});
    }
  }

  handleSelectFieldChange(event, index, value) {
    this.setState({project: value});
  }

  handleTaskChange(event) {
    this.setState({taskName: event.target.value});
  }

  handleHoursChange(event) {
    this.setState({hoursADay: event.target.value});
  }

  handleStartAtChange(event, date) {
    this.setState({startAt: date});
  }

  handleEndAtChange(event, date) {
    this.setState({endAt: date});
  }

  renderStepActions(step) {
    const {stepIndex} = this.state;

    return (
      <div style={{margin: '12px 0'}}>
        <RaisedButton
          label={stepIndex === 2 ? 'Finish' : 'Next'}
          disableTouchRipple={true}
          disableFocusRipple={true}
          primary={true}
          onTouchTap={this.handleNext}
          style={{marginRight: 12}}
        />
        {step > 0 && (
          <FlatButton
            label="Back"
            disabled={stepIndex === 0}
            disableTouchRipple={true}
            disableFocusRipple={true}
            onTouchTap={this.handlePrev}
          />
        )}
      </div>
    );
  }

  render() {
    const {
      stepIndex,
      project,
      taskName,
      hoursADay,
      startAt,
      endAt,
      projectHasError,
      taskNameHasError,
      hoursADayHasError,
      startAtHasError,
      endAtHasError
    } = this.state;

    return (
      <div>
        <h1>New Task</h1>
        <div>
          <span>I do </span>
          <span>
            <strong>{taskName !== '' ? taskName : '?'}</strong>
            ,
          </span>
          <span>
            <strong>{project !== null ? hoursADay : '?'}</strong>
          </span>
          <span> hours /day for </span>
          <span>
            <strong>{project !== null ? project.name : '?'}</strong>
          </span>
          <span>, </span>
          <span> from </span>
          <span>
            <strong>{startAt !== null ? (`${startAt.getFullYear()}-${startAt.getMonth()+1}-${startAt.getDate()}`) : '?'}</strong>
          </span>
          <span> to </span>
          <span>
            <strong>{endAt !== null ? (`${endAt.getFullYear()}-${endAt.getMonth()+1}-${endAt.getDate()}`) : '?'}</strong>
          </span>
        </div>
        <Slider value={stepIndex} max={3} min={0}/>

        <div style={{width: 380, height: 400, margin: 'auto'}}>
          <Stepper activeStep={stepIndex} orientation="vertical">
            <Step>
              <StepLabel>Select project</StepLabel>
              <StepContent>
                <p>
                  Select the project this new task blonging to.
                </p>
                <SelectField
                  style={{whiteSpace: 'nowrap'}}
                  value={this.state.project}
                  onChange={this.handleSelectFieldChange}
                  errorText={projectHasError ? 'Should select project' : ''}>
                  {this.props.projects.map((p, i) => {
                    return <MenuItem
                      value={p}
                      primaryText={`${p.code}-${p.name}`}
                      key={i} />
                  })}
                </SelectField>
                {this.renderStepActions(0)}
              </StepContent>
            </Step>
            <Step>
              <StepLabel>Task name / Hours a day</StepLabel>
              <StepContent>
                <p>Input what you do.</p>
                <TextField
                  hintText="Task name"
                  value={taskName}
                  errorText={taskNameHasError ? 'You should input task name' : ''}
                  onChange={this.handleTaskChange}
                />
                <p>Input how long do you do that.</p>
                <TextField
                  hintText="Hours a day"
                  type="number"
                  value={hoursADay}
                  errorText={hoursADayHasError ? 'You should input hours a day' : ''}
                  onChange={this.handleHoursChange}
                />
                {this.renderStepActions(1)}
              </StepContent>
            </Step>
            <Step>
              <StepLabel>Set task schedule</StepLabel>
              <StepContent>
                <p>
                  Pick the day this task will start at
                </p>
                <DatePicker
                  hintText="Start at"
                  mode="landscape"
                  value={startAt}
                  errorText={startAtHasError? 'You should input start at' : ''}
                  onChange={this.handleStartAtChange}
                />
                <p>
                  Pick the day this task will end at
                </p>
                <DatePicker
                  hintText="End at"
                  mode="landscape"
                  value={endAt}
                  errorText={endAtHasError? 'You should input end at' : ''}
                  onChange={this.handleEndAtChange}
                />
                {this.renderStepActions(2)}
              </StepContent>
            </Step>
          </Stepper>
        </div>
      </div>
    )
  }
}

NewTaskPage.propTypes = {
  projectActions: PropTypes.object.isRequired,
  taskActions: PropTypes.object.isRequired,
  projects: PropTypes.array.isRequired
};

function mapStateToProps(state) {
  return {
    projects: state.project.items
  };
}

function mapDispatchToProps(dispatch) {
  return {
    projectActions: bindActionCreators(projectActions, dispatch),
    taskActions: bindActionCreators(taskActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewTaskPage);



/** WEBPACK FOOTER **
 ** ./src/components/NewTaskPage.js
 **/